/* Script Load Cart */

$('.open-cart-rebuy').click(function() {
  cartLoad();
});

function cartLoad(){
  if (typeof Rebuy === 'undefined' || typeof Rebuy.SmartCart === 'undefined' || typeof Rebuy.SmartCart.show !== 'function') {
    RebuyPreload();
  } else {
    Rebuy.SmartCart.show();
  };
};

function RebuyPreload(){
  $('body').addClass('show-cart-preload');
};

function cartReady(){
  if ($('body').hasClass('show-cart-preload')) {
    setTimeout(function() {
      $('body').removeClass('show-cart-preload');
      Rebuy.SmartCart.show();
    }, 1000);
  };
};


function notesGift(){
  var $input = $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle .rebuy-cart__flyout-note-toggle-input');
  var $label = $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle .rebuy-cart__flyout-note-toggle-label');
  $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle').prepend('<div class="rebuy-cart__note-text"><span>Is This a Gift?</span></div>');
  $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle').append('<div class="rebuy-cart__note-label"></div>');
  $( "#rebuy-cart .rebuy-cart__flyout-note-toggle .rebuy-cart__note-label" ).append( $($input),$($label) );
};


function $renderContainer(){

  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(

      '<div class="container-progress-bar">' +

        '<div class="elements-progress-bar">' +
      
            '<h3 class="progress-bar__title">Free shipping on orders over $99</h3>'+
            
            '<section class="progress-bar-cart">'+
            
            	'<div class="progress-bar-cart__container">'+
            		'<div id="progress-bar__free-shipping" class="progress-bar-cart__bar"></div>'+
            	'</div>'+
            
            	'<div class="progress-bar__icon">'+
            		'<div id="container-icon__free-shipping" class="progress-bar__icon-container">'+
            			'<i id="icon__free-shipping" class="fas fa-lock"></i>'+
            		'</div>'+
            		'<p class="progress-bar__icon-text">Free Shipping</p>'+
            	'</div>'+
      
      
              '<div class="progress-bar-cart__container">'+
            		'<div id="progress-bar__pouch" class="progress-bar-cart__bar"></div>'+
            	'</div>'+
            
            	'<div class="progress-bar__icon">'+
            		'<div id="container-icon__pouch" class="progress-bar__icon-container">'+
            			'<i id="icon__pouch" class="fas fa-lock"></i>'+
            		'</div>'+
            		'<p class="progress-bar__icon-text">Gift Card</p>'+
            	'</div>'+
            
            '</section>'+
    
            '<div class="disclaimer-message">'+
    
              '<p>* Gift card on orders over $150.</p>' +
              '<p>** Gift card will be sent after completing the purchase.</p>' +
        
            '</div>' +

        '</div>' +

    '</div>'
  );
  
};


function $progressBar(totalPrice,arrayProducts){

    var $total_price = totalPrice;
    var $array_products = arrayProducts;

    var $price_promotion_one = 9900 - $total_price; var $promotion_one = $price_promotion_one /= Math.pow(10, 2); var $porcentPromotionOne = ((99.00 - $promotion_one) / 99.00 * 100) + "%";
    var $price_promotion_two = 15000 - $total_price; var $promotion_two = $price_promotion_two /= Math.pow(10, 2); var $porcentPromotionTwo = ((150.00 - $promotion_two) / 150.00 * 100) + "%";
  
    if($total_price <= 0){

      $("#progress-bar__free-shipping,#progress-bar__5-off,#progress-bar__pouch").animate({width: "0%",}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": "#fff", "border-color": "#000"});
      $("#icon__free-shipping,#icon__pouch").css("color", "#000");
      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Free shipping on orders over $99</h3>');
      
    } else if($total_price > 0 && $total_price <= 9899){

      $("#progress-bar__free-shipping").animate({width: $porcentPromotionOne,}, 500);
      $("#progress-bar__pouch").animate({width: "0%",}, 500);
      
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": "#fff", "border-color": "#000"});
      $("#icon__free-shipping,#icon__pouch").css("color", "#000");

      $(".progress-bar__title").replaceWith(
        '<div class="progress-bar__title">'+
          '<h3>You need <b>$' + $promotion_one + '</b> to get free shipping</h3>'+
        '</div>'
      );

    } else if($total_price >= 9900 && $total_price <= 14999){

      $("#progress-bar__free-shipping").animate({width: "100%",}, 500);
      $("#progress-bar__pouch").animate({width:$porcentPromotionTwo,}, 500);
      
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');
      
      $("#container-icon__free-shipping").css({"background-color": "#000", "border-color": "#000"});
      $("#container-icon__pouch").css({"background-color": "#fff", "border-color": "#000"});
            
      $("#icon__free-shipping").css("color", "#fff");
      $("#icon__pouch").css("color", "#000");

      $(".progress-bar__title").replaceWith(
        '<div class="progress-bar__title">'+
          '<h3>You Unlocked Free Shipping</h3>'+
          '<h5>You need <b>$' + $promotion_two + '</b> to get gift card</h5>'+
        '</div>'
      );

    } else if($total_price >= 15000){

      $("#progress-bar__free-shipping").animate({width: "100%",}, 500);
      $("#progress-bar__pouch").animate({width: "100%",}, 500);

      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-check-circle"></i>');

      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": "#000", "border-color": "#000"});

      $("#icon__free-shipping,#icon__pouch").css("color", "#fff");

      $(".progress-bar__title").replaceWith(
          '<div class="progress-bar__title">'+
            '<h3>You Unlocked Free Shipping + Gift Card</h3>'+
            '<div class="container-form-gift">' +
              '<p>The gift card will be sent after completing the purchase via email.</p>'+
            '</div>' +
          '</div>'
        );
      
    };
  
};



/* Script Events Rebuy */

document.addEventListener('rebuy:smartcart.ready', function(event){
  var qty = event.detail.smartcart.cart.item_count;
  cartReady();
  notesGift();

  var $total_price = event.detail.smartcart.cart.total_price;
  var $array_products = event.detail.smartcart.cart.items;
  $renderContainer();
  $progressBar($total_price,$array_products);

  if (qty > 0){
    $('#rebuy-cart .rebuy-cart__flyout-note').show();
  } else {
    $('#rebuy-cart .rebuy-cart__flyout-note').hide();
  };
  
});

document.addEventListener('rebuy:cart.change', function(event){
  var qty = event.detail.cart.cart.item_count;
  $('.open-cart-rebuy .cart-count-bubble span').text(qty);

  var $container_progress = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .container-progress-bar');
  var $total_price = event.detail.cart.cart.total_price;
  var $array_products = event.detail.cart.cart.items;
  if ($container_progress.length > 0) {
    $progressBar($total_price,$array_products);
  };

  if (qty > 0){
    $('#rebuy-cart .rebuy-cart__flyout-note').show();
  } else {
    $('#rebuy-cart .rebuy-cart__flyout-note').hide();
  };
  
});